// ** Type Imports
import { Palette, Theme } from "@mui/material";

const defaultPalette = (theme: Theme): Palette => {
  const customPalette: Palette = {
    contrastThreshold: 4.5,
    mode: "light",
    common: {
      black: "#000",
      white: "#FFF",
    },
    primary: theme.palette.augmentColor({
      color: {
        main: "#004225",
        light: "#c0d6cc",
      },
      name: "primary",
    }),
    primaryExtraLight: theme.palette.augmentColor({
      color: {
        main: "#bfd9ce",
      },
      name: "primary",
    }),
    secondary: {
      main: "rgba(99, 102, 113, 1)",
      light: "rgb(228, 228, 231)",
    },
    error: theme.palette.augmentColor({
      color: {
        dark: "rgba(153, 10, 14, 1)",
        main: "rgba(239, 69, 81, 1)",
        // light: "rgba(239, 69, 81, 0.2)",
        light: "#f8d8db",
      },
      name: "error",
    }),
    warning: {
      main: "rgb(193, 164, 20)",
      // light: "rgba(193, 164, 20, 0.2)",
      light: "#eeead3",
    },
    info: {
      main: "rgba(9, 99, 201, 1)",
      // light: "rgba(9, 99, 201, 0.1)",
      light: "#e4ecf5",
    },
    success: {
      main: "rgba(21, 166, 13, 1)",
      // light: "rgba(21, 166, 13, 0.2)",
      light: "#d4e9d2",
    },
    grey: {
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#E0E0E0",
      400: "#BDBDBD",
      500: "#9E9E9E",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#F5F5F5",
      A200: "#EEEEEE",
      A400: "#BDBDBD",
      A700: "#616161",
    },
    text: {
      primary: "rgb(0, 0, 0)",
      secondary: "rgba(0, 0, 0, 0.7)",
      disabled: "rgba(0, 0, 0, 0.45)",
    },
    background: {
      paper: "#FFF",
      default: "#fafafa",
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.04)",
      selected: "rgba(0, 0, 0, 0.08)",
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      focus: "rgba(0, 0, 0, 0.12)",
    },
    custom: {
      main: "#FFF",
    },
    alert: {
      info: "rgb(237, 246, 253)",
      error: "rgb(253, 237, 237)",
    },
  } as Palette;

  return customPalette;
};

export default defaultPalette;
